// extracted by mini-css-extract-plugin
export var activeFilterButton = "_o8-c";
export var backButton = "_o8-4";
export var backIcon = "_o8-5";
export var chevronShortcut = "_o8-6";
export var container = "_o8-1";
export var editor = "_o8-8";
export var editorWrapper = "_o8-7";
export var prefix = "_o8-2";
export var searchIcon = "_o8-3";
export var suffix = "_o8-9";
export var suffixContent = "_o8-a";
export var suffixText = "_o8-b";
export var wrapper = "_o8-0";